var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.811,
    height: 17.777,
    viewBox: "0 0 14.811 17.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23c95d",
    d: "M9.257,17.777a1.112,1.112,0,0,1-1.111-1.111V14.075H6.665v2.592a1.111,1.111,0,1,1-2.221,0V14.037a1.858,1.858,0,0,1-1.481-1.814V6.3a.371.371,0,0,1,.37-.37h8.146a.371.371,0,0,1,.37.37v5.924a1.858,1.858,0,0,1-1.481,1.814v2.629A1.112,1.112,0,0,1,9.257,17.777ZM13.7,13.334a1.112,1.112,0,0,1-1.111-1.111V7.039a1.111,1.111,0,0,1,2.222,0v5.184A1.112,1.112,0,0,1,13.7,13.334Zm-12.59,0A1.112,1.112,0,0,1,0,12.223V7.039a1.111,1.111,0,0,1,2.222,0v5.184A1.112,1.112,0,0,1,1.111,13.334ZM11.478,5.188H3.332a.371.371,0,0,1-.37-.371A3.9,3.9,0,0,1,4.713,1.539l-.9-.9A.37.37,0,0,1,4.335.112L5.387,1.164a5.071,5.071,0,0,1,4.038,0L10.476.113l.006-.007,0,0A.37.37,0,1,1,11,.636l-.9.9a3.894,3.894,0,0,1,1.751,3.279A.371.371,0,0,1,11.478,5.188ZM9.257,2.966a.37.37,0,1,0,.37.37A.371.371,0,0,0,9.257,2.966Zm-3.7,0a.37.37,0,1,0,.37.37A.371.371,0,0,0,5.554,2.966Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidSm);
export default __webpack_public_path__ + "static/media/android-sm.c08c410a.svg";
export { ForwardRef as ReactComponent };